import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuelRealtimeConsumptionComponent } from './fuel-realtime-consumption.component';
import {FuelHourlyConsumptionChartModule} from '../fuel-hourly-consumption-chart/fuel-hourly-consumption-chart.module';



@NgModule({
  declarations: [FuelRealtimeConsumptionComponent],
  imports: [
    CommonModule,
    FuelHourlyConsumptionChartModule
  ],
  exports: [FuelRealtimeConsumptionComponent]
})
export class FuelRealtimeConsumptionModule { }
